import { trpc } from '../lib/trpc';
import { useAuth } from '../hooks/useAuth';

interface WishlistInBoundsChipProps {
  bounds:
    | {
        sw: { lat: number; lng: number };
        ne: { lat: number; lng: number };
      }
    | null;
}

export const WishlistInBoundsChip = ({ bounds }: WishlistInBoundsChipProps) => {
  const { user } = useAuth();
  const query = trpc.user.wishlistMatchInBounds.useQuery(
    { bounds: bounds! },
    { enabled: Boolean(user && bounds) }
  );

  if (!user || !bounds || !query.data || query.data.count === 0) return null;

  return (
    <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary-50 text-primary-800 border border-primary-200 text-xs font-sans">
      {query.data.count === 1
        ? '1 of your wishlist wines is in this area'
        : `${query.data.count} of your wishlist wines are in this area`}
    </div>
  );
};
